// Procore routes only exist under /user, so these calls are always
// user-scoped; the company is passed explicitly as a query param.
const PENDING_COMPANY_KEY = "procore_connect_company_uuid";

function url(path, companyUuid) {
  return `${process.env.REACT_APP_API_BASE_URL}/user/integration/procore${path}?company_uuid=${companyUuid}`;
}

async function call(method, path, companyUuid, body) {
  const auth_token = sessionStorage.getItem("token");
  const request = new Request(url(path, companyUuid), {
    method,
    headers: new Headers({
      "Content-Type": "application/json",
      Authorization: auth_token,
    }),
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    const response = await fetch(request);
    const json = await response.json().catch(() => ({}));
    return {
      status: response.status,
      data: response.ok ? json.data || json : null,
      message: json.message,
    };
  } catch (err) {
    return { status: 0, data: null };
  }
}

export function getPendingCompanyUuid() {
  return sessionStorage.getItem(PENDING_COMPANY_KEY) || "";
}

export function clearPendingCompanyUuid() {
  sessionStorage.removeItem(PENDING_COMPANY_KEY);
}

export default {
  getProcoreStatus: (companyUuid) => call("GET", "", companyUuid),

  // Remembers the company so the callback page acts on the one the admin
  // started from, even if the selection changed during the Procore login.
  connectProcore: async function (companyUuid) {
    const result = await call("POST", "/connect", companyUuid);
    if (result.status === 200 && result.data?.authorize_url) {
      sessionStorage.setItem(PENDING_COMPANY_KEY, companyUuid);
    }
    return result;
  },

  completeProcoreCallback: (companyUuid, code, state) =>
    call("POST", "/callback", companyUuid, { code, state }),

  setProcoreCompany: (companyUuid, procoreCompanyId) =>
    call("PUT", "", companyUuid, { procore_company_id: procoreCompanyId }),

  disconnectProcore: (companyUuid) => call("DELETE", "", companyUuid),
};
